import React from 'react';
import { ChefAvailabilityContext } from './ChefAvailabilityContext.js';
import { CHEF_PORTAL_HOST } from '../../const';

class ChefAvailabilitySection extends React.Component {
  state = {
    isEdit: false
  };

  render() {
    const { chef } = this.props 
    const chefEmail = chef ? chef.email : ''
    const chefPortal = `//${CHEF_PORTAL_HOST}/schedule?email=${encodeURIComponent(chefEmail)}`
    return (
      <div className="cms__section">
        <ChefAvailabilityContext.Provider value={this.state}>
          <div className="cms__bar cms__section-head">
            <div className="cms__bar-left">
              <h3 className="h3">Availability</h3>
            </div>
          </div>
          <div className="cms__section-body chef-availability">
            <a href={chefPortal}>Manage Your Schedule</a>
          </div>
        </ChefAvailabilityContext.Provider>
      </div>
    );
  }

  cancelEdit = () =>
    this.setState({ isEdit: false }, this.props.revertAvailability);

  toggleEdit = () => this.setState({ isEdit: !this.state.isEdit });

  deleteTimeOff = index => {
    const chef_time_offs = [
      ...this.props.timeOff.slice(0, index),
      ...this.props.timeOff.slice(index + 1, this.props.timeOff.length)
    ];
    this.props.updateChef({ chef_time_offs });
  };
}
export default ChefAvailabilitySection;



// WEBPACK FOOTER //
// ./src/components/chef/ChefAvailabilitySection.js